import { defaultEnvironment } from './environment.default';

export const environment = {
  ...defaultEnvironment,
  dev: true,
};
